import { Realty } from '@ambita/ambita-components-core';
import { ApiPlot } from '../../../typings/CadastreReport';

function transformPlots(plotsData: Realty.ApiResponse) {
  if (plotsData.items && plotsData.items.length > 0) {
    const plots: ApiPlot[] = plotsData.items;
    const returnObject: any = {
      coordinates: [],
      numberOfPlots: plots.length,
      areaNotes: []
    };

    plots.forEach((plot: any) => {
      returnObject.coordinates.push(plot.position.geometry.coordinates);

      plot.areaNotes.forEach((areaNote) => {
        const filteredAreaNote = returnObject.areaNotes.filter(addedAreaNote => addedAreaNote.code === areaNote.code);

        if (filteredAreaNote.length === 0) {
          returnObject.areaNotes.push(areaNote);
        }
      });
    });

    return returnObject;
  }
}

export default transformPlots;
